import moment from "moment";
import React, { Component } from "react";
import "./ActionButtons.scss";
import imgCancelApplication from "../../../images/cancel-application.png";
import imgChangeOwnership from "../../../images/change-ownership.png";
import imgReRunApplication from "../../../images/rerun-application.png";
import imgCopyApplication from "../../../images/copy-application.png";
import imgBankIcon from "../../../images/bank.png";

class ActionButtons extends Component {
    constructor(props) {
        super(props);
        this.state = {
            salesAdmin: false,
            showButtons: false,
            hideMenuOptions: false,
            emsAdmin: false,
        };
    }

    handleAssignBank(childApp = true) {
        if (this.props.onAssignBank) {
            this.props.onAssignBank(this.props.preapp, childApp);
        }
    }

    handleCancel() {
        if (this.props.onCancel) {
            this.props.onCancel(this.props.preapp);
        }
    }

    handleChangeOwnership() {
        if (this.props.onChangeOwnership) {
            this.props.onChangeOwnership();
        }
    }

    handleReRun() {
        if (this.props.onReRun) {
            this.props.onReRun(this.props.preapp);
        }
    }

    handleCopy() {
        if (this.props.onCopy) {
            this.props.onCopy(this.props.preapp);
        }
    }
    componentDidMount() {
        if (this.props.user && this.props.user.channel == "sales_channel") {
            this.setState({ hideMenuOptions: true });
            if (this.props.user?.organization?.id == 1) {
                this.setState({
                    salesAdmin: true,
                });
            }
        }

        if(this.props.user?.is_ems_pc_admin) {
            this.setState({
                emsAdmin: true,
            });
        }
    }
    render() {
        const { showButtons, preapp, pci_admin } = this.props;
        const { hideMenuOptions, salesAdmin, emsAdmin } = this.state;
        const showAssignBank =
            (this.props.showAssignBank && pci_admin) || false;
        const assignBankText = preapp.child
            ? preapp.child.length > 0
                ? false
                : true
            : true;
        const showMerchantColumn = this.props.showMerchantColumn || false;
        return (
            <div
                className={
                    this.props.user.role !== "agent"
                        ? "action-buttons"
                        : "action-buttons action-btn-agent"
                }
            >
                {showButtons ? (
                    <div
                        className={
                            showAssignBank
                                ? "buttons"
                                : "buttons hide-assign-btn"
                        }
                    >
                        {this.props.user &&
                        this.props.user.channel == "sales_channel" ? (
                                <>
                                    <div className="hoveractionbutton">
                                        <a
                                            className="btn btn-light btn-xs "
                                            onClick={() => this.handleCancel()}
                                            title="Cancel Application"
                                        >
                                            <img
                                                src={imgCancelApplication}
                                                style={{
                                                    width: "12px",
                                                    height: "12px",
                                                }}
                                            />
                                        </a>
                                        <a
                                            className="btn btn-light btn-xs "
                                            onClick={() => this.handleCopy()}
                                            title="Copy application"
                                            data-for="copy"
                                        >
                                            <img
                                                src={imgCopyApplication}
                                                style={{
                                                    width: "25px",
                                                    height: "25px",
                                                }}
                                            />
                                        </a>
                                    </div>

                                {salesAdmin ? (
                                    <>
                                    <div className="hoveractionbutton">
                                      <>          
                                        {this.props.showAssignBank &&                                          
                                            <>
                                                <a
                                                    title="Assign MSP"
                                                    className="btn btn-light btn-xs "
                                                    onClick={() =>
                                                        this.handleAssignBank(false)
                                                    }
                                                >
                                                    {" "}
                                                    {preapp.bank_id !== null
                                                        ? "Change MSP"
                                                        : "Assign MSP"}
                                                </a>
                                                <span className="button-separator btn-sep">
                                                    |
                                                </span>                                  
                                              <a
                                                  title="Assign MSP"
                                                  className="btn btn-light btn-xs childapp-btn"
                                                  onClick={() =>
                                                      this.handleAssignBank()
                                                  }
                                              >
                                                  &#43;
                                              </a>
                                              <span className="button-separator btn-sep">
                                                  |
                                              </span>
                                            </>
                                          }  
                                        </>                             
                                        <a
                                            className="btn btn-light btn-xs "
                                            onClick={() => this.handleCopy()}
                                            title="Copy application"
                                            data-for="copy"
                                        >
                                            <img
                                                src={imgCopyApplication}
                                                style={{
                                                    width: "25px",
                                                    height: "25px",
                                                }}
                                            />
                                        </a>       
                                                                   
                         
                                        <a
                                            className="btn btn-light btn-xs "
                                            onClick={() =>
                                                this.handleChangeOwnership()
                                            }
                                            title="Change ownership"
                                            data-for="ownership"
                                        >
                                            <img
                                                src={imgChangeOwnership}
                                                style={{
                                                    width: "25px",
                                                    height: "25px",
                                                }}
                                            />
                                        </a>
                                    </div>                  
                                </>                                    
                                ) : (
                                    <>
                                      <div>
                                        {emsAdmin && (
                                          <a
                                              className="btn btn-light btn-xs "
                                              onClick={() =>
                                                  this.handleChangeOwnership()
                                              }
                                              title="Change ownership"
                                              data-for="ownership"
                                          >
                                              <img
                                                  src={imgChangeOwnership}
                                                  style={{
                                                      width: "25px",
                                                      height: "25px",
                                                  }}
                                              />
                                          </a>
                                        )}
                                      </div>
                                    </>
                                )}
                            </>
                        ) : (
                            <div className="hoveractionbutton">
                                {showAssignBank &&
                                    assignBankText &&
                                    pci_admin && (
                                        <>
                                            <a
                                                title="Assign MSP"
                                                className="btn btn-light btn-xs "
                                                onClick={() =>
                                                    this.handleAssignBank(false)
                                                }
                                            >
                                                {" "}
                                                {preapp.bank_id !== null
                                                    ? "Change MSP"
                                                    : "Assign MSP"}
                                            </a>
                                            <span className="button-separator btn-sep">
                                                |
                                            </span>
                                        </>
                                    )}

                                {showAssignBank && pci_admin && (
                                    <>
                                        <a
                                            title="Assign MSP"
                                            className="btn btn-light btn-xs childapp-btn"
                                            onClick={() =>
                                                this.handleAssignBank()
                                            }
                                        >
                                            &#43;
                                        </a>
                                        <span className="button-separator btn-sep">
                                            |
                                        </span>
                                    </>
                                )}

                                {pci_admin == undefined ? (
                                    <div>
                                        <a
                                            title="Change MSP"
                                            className="btn btn-light btn-xs "
                                            onClick={() =>
                                                this.handleAssignBank(false)
                                            }
                                        >
                                            Change MSP
                                        </a>
                                        <span className="button-separator btn-sep">
                                            |
                                        </span>
                                    </div>
                                ) : (
                                    <div></div>
                                )}
                                {pci_admin && preapp.progression_id < 8 ? (
                                    <a
                                        className="btn btn-light btn-xs "
                                        onClick={() =>
                                            this.props.handleChangeBank()
                                        }
                                        title="Assign Processor"
                                        data-for="assign-processor"
                                    >
                                        <img
                                            src={imgBankIcon}
                                            style={{
                                                width: "18px",
                                                height: "18px",
                                            }}
                                        />
                                    </a>
                                ) : (
                                    <></>
                                )}

                                {hideMenuOptions == false ? (
                                    <a
                                        className="btn btn-light btn-xs "
                                        onClick={() => this.handleCancel()}
                                        title="Cancel Application"
                                    >
                                        <img
                                            src={imgCancelApplication}
                                            style={{
                                                width: "12px",
                                                height: "12px",
                                            }}
                                        />
                                    </a>
                                ) : (
                                    <></>
                                )}
                                {pci_admin ? (
                                    <a
                                        className="btn btn-light btn-xs "
                                        onClick={() =>
                                            this.handleChangeOwnership()
                                        }
                                        title="Change ownership"
                                        data-for="ownership"
                                    >
                                        <img
                                            src={imgChangeOwnership}
                                            style={{
                                                width: "25px",
                                                height: "25px",
                                            }}
                                        />
                                    </a>
                                ) : (
                                    <div></div>
                                )}
                                {pci_admin ? (
                                    <a
                                        className="btn btn-light btn-xs "
                                        onClick={() => this.handleReRun()}
                                        title="Re-run application"
                                        data-for="re-run"
                                    >
                                        <img
                                            src={imgReRunApplication}
                                            style={{
                                                width: "12px",
                                                height: "12px",
                                            }}
                                        />
                                    </a>
                                ) : (
                                    <div></div>
                                )}
                                {hideMenuOptions == false ? (
                                    <a
                                        className="btn btn-light btn-xs "
                                        onClick={() => this.handleCopy()}
                                        title="Copy application"
                                        data-for="copy"
                                    >
                                        <img
                                            src={imgCopyApplication}
                                            style={{
                                                width: "25px",
                                                height: "25px",
                                            }}
                                        />
                                    </a>
                                ) : (
                                    <></>
                                )}
                            </div>
                        )}
                    </div>
                ) : (
                    <>
                        <div className="col-created-at">
                            {preapp.created_at != null ? (
                                moment(preapp.created_at).format("MMM D, YYYY")
                            ) : (
                                <>&mdash;</>
                            )}
                        </div>
                    </>
                )}
            </div>
        );
    }
}

export default ActionButtons;
